import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/rootReducer";
import { CheckoutData, PaymentState } from "./types";
import { API_URL } from "config";
import axios from "axios";
import { setCurrentStep } from "features/cart/cartSlice";
import { setMessage } from "features/message/messageSlice";
import { MessageType } from "features/message/types";

const initialState: PaymentState = {
  isCheckoutSuccessful: false,
  checkoutLoading: false,
  checkoutError: null,
};

const payment = createSlice({
  name: "paymentSlice",
  initialState,
  reducers: {
    checkoutStart(state) {
      state.checkoutLoading = true;
      state.checkoutError = null;
    },
    checkoutSuccess(state) {
      state.checkoutLoading = false;
      state.isCheckoutSuccessful = true;
      state.checkoutError = null;
    },
    checkoutError(state, action) {
      state.checkoutLoading = false;
      state.checkoutError = action.payload;
      state.isCheckoutSuccessful = false;
    },
  },
});
export const { checkoutStart, checkoutSuccess, checkoutError } =
  payment.actions;
export const selectIsCheckoutSuccessful = (state: RootState) =>
  state.payment.isCheckoutSuccessful;
export const selectCheckoutLoading = (state: RootState) =>
  state.payment.checkoutLoading;
export const selectCheckoutError = (state: RootState) =>
  state.payment.checkoutError;

export const checkout =
  (
    data: CheckoutData,
    onUploadProgress?: (e: ProgressEvent<EventTarget>) => void
  ) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(checkoutStart());
      const response = await axios.post(
        `${API_URL}/checkout`,
        {
          data,
        },
        { onUploadProgress }
      );
      if (response.status === 200 && response.data.hasOwnProperty("errors")) {
        dispatch(checkoutError("Моля опитайте отново или се свържете с нас."));
      }
      if (response.status === 201) {
        dispatch(checkoutSuccess());
        const currentStep = getState().cart.currentStep;
        dispatch(setCurrentStep(currentStep + 1));
      } else {
        dispatch(checkoutError("Неуспешен опит, моля опитайте отново."));
      }
    } catch (error: any) {
      dispatch(checkoutError("Неуспешен опит, моля опитайте отново."));
    }
  };

export const fastOrder =
  (data: {
    number: string;
    names: string;
    item: { title: string; alias: string; objectType: string };
  }) =>
  async (dispatch: any) => {
    try {
      const response = await axios.post(`${API_URL}/fast-order`, {
        data,
      });
      dispatch(
        setMessage({
          text: `Поръчката е направена, очаквайте обаждане от наш сътрудник.`,
          type: MessageType.success,
        })
      );
    } catch (error: any) {
      dispatch(
        setMessage({
          text: `Възника грешка, моля да ни извините. Моля опитайте отново.`,
          type: MessageType.danger,
        })
      );
    }
  };
export default payment.reducer;
